import React from "react";
import icon from "../../../assets/vp-personal-detail-icon.png";
import { Icon } from "@iconify/react/dist/iconify.js";

function VPAccountDetails({ userInfo }) {
  return (
    <div className="vp-supplier-type mb-3">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center">
            <Icon icon="hugeicons:bank" color="#eb662b" fontSize={20} />
            <h5 className="m-0 ms-2 vp-supplier-type-title">Account details</h5>
          </div>
        </div>
        <div className="card-body">
          <div className="d-flex flex-column w-100 gap-2">
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Account title</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.bank_details?.account_holder_name}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">IBAN/Account no</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.bank_details?.account_number}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Bank name</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.bank_details?.bank_name}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VPAccountDetails;
